import React from 'react'
import { Space, Table, Tag } from 'antd';
import { useState, useEffect } from 'react';
import AdminSidebar from "./AdminSidebar";

const columns = [
  {
    title: 'Sr No.',
    render(text, record, index) {
      return {
        children: <div style={{ fontWeight: '600', textTransform: 'capitalize' }}>{index + 1}</div>
      }
    }
  },
  {
    title: 'Name',
    dataIndex: 'Name',
    render(text) {
      return {
        props: {
          style: { fontSize: "16px", textAlign: "center", color: '#483a15' }
        },
        children: <div style={{ fontWeight: '600' }}  >{text}</div>
      }
    }
  },
  {
    title: 'E-mail Id',
    dataIndex: 'Email',
    render(text) {
      return {
        props: {
          style: { fontSize: "16px", textAlign: "center", color: '#483a15' }
        },
        children: <div style={{ fontWeight: '600' }}  >{text}</div>
      }
    }
  },
  {
    title: 'Reason',
    dataIndex: 'Reason',
    render(text) {
      return {
        props: {
          style: { fontSize: "16px", textAlign: "center", color: '#483a15' }
        },
        children: <div style={{ fontWeight: '600' }}  >{text}</div>
      }
    }
  },
  {
    title: 'Time',
    dataIndex: 'Date',
    render(text) {
      return {
        props: {
          style: { fontSize: "16px", textAlign: "center", color: '#483a15' }
        },
        children: <div style={{ fontWeight: '600' }}  >{text}</div>
      }
    }
  },
]




function AdminDeleteRequest() {



  const [contactData, setcontactData] = useState([])
  useEffect(() => {

    var Url = window.API_PREFIX + 'admin/all_delete_request?Token=' + localStorage.getItem("DToken")
    fetch(Url, {
      method: 'Get',

    }).then(resp => resp.json()).then(data => {

      if (data['status'] === "1") { setcontactData([...data['all_contacts']]) }

    }
    )
  }, [])



  return (
    <>

      <div className="container-fuild mx-2">
        <Table columns={columns} dataSource={contactData} />
      </div>

    </>
  )
}

export default AdminDeleteRequest